<template>
    <div class="pagination pt40">
            <el-pagination
                background
                layout="prev, pager, next"
                :page-count="page_count"
                @prev-click='prevClick'
                @next-click='nextClick'
                @current-change='currentChange'
                >
            </el-pagination>
        </div>
</template>
<script>
export default {
    name: 'myPagination',
    props: ['page_count'],
    data(){
        return {

        }
    },
    methods: {
        prevClick(){
            this.$emit('prevClick')
        },
        nextClick(){
            this.$emit('nextClick')
        },
        currentChange(v){
            this.$emit('currentChange',v)
        }
    }

}
</script>